import tokens from './tokens'
import { FarmConfig } from './types'

const farms: FarmConfig[] = [
  /**
   * These 3 farms (PID 0,2,3) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'AXD',
    lpAddresses: {
      97: '  ',
      56: '0xb26820dacbcc00ef870d56f4e81905239cc2acb6',
    },
    token: tokens.syrup,
    quoteToken: tokens.wbnb,
  },
  
 {
    pid: 1,
    lpSymbol: 'AXD-BNB LP',
    lpAddresses: {
      97: '0x4525ef73b2ce7cd52ac2fe6dd6ca87eee8f42f76',
      56: '0x4525ef73b2ce7cd52ac2fe6dd6ca87eee8f42f76',
    },
    token: tokens.axd,
    quoteToken: tokens.wbnb,
  }, 
  
  {
    pid: 10,
    lpSymbol: 'AXD-USDT * pancakeswap V2 LP',
    lpAddresses: {
      97: '0xa9eddb25edd01fe60157604132e5e20caab50580',
      56: '0xa9eddb25edd01fe60157604132e5e20caab50580',
    },
    token: tokens.axd,
    quoteToken: tokens.usdt,
  },
  
    {
    pid: 9,
    lpSymbol: 'AXT-BNB LP',
    lpAddresses: {
      97: '0x2520264f6cc7191c2d64e1c5c4ad87f298a362db',
      56: '0x2520264f6cc7191c2d64e1c5c4ad87f298a362db',
    },
    token: tokens.axt,
    quoteToken: tokens.wbnb,
  },

  {
    pid: 2,
    lpSymbol: 'BUSD-BNB LP',
    lpAddresses: {
      97: '0x96eaf11b65c29a843d1d4e1ab9e10d030e3372e0',
      56: '0x96eaf11b65c29a843d1d4e1ab9e10d030e3372e0',
    },
    token: tokens.busd,
    quoteToken: tokens.wbnb,
  }, 
// **************************  added tokens ************************
   {
    pid: 3,
    lpSymbol: 'BTCB-USDT LP',
    lpAddresses: {
      97: '0x874a7d6cd13ac28c5d2df5d991d15b2bfb690869',
      56: '0x874a7d6cd13ac28c5d2df5d991d15b2bfb690869',
    },
    token: tokens.btcb,
    quoteToken: tokens.usdt,
  },
   
   {
    pid: 4,
    lpSymbol: 'ETH-USDT LP',
    lpAddresses: {
      97: '0x0f314cf5280d2dfd6ad1c792757c4a3913c0b2b1',
      56: '0x0f314cf5280d2dfd6ad1c792757c4a3913c0b2b1',
    },
    token: tokens.eth,
    quoteToken: tokens.usdt,
  },
  
 {
    pid: 5,
    lpSymbol: 'USDC-USDT LP',
    lpAddresses: {
      97: '0x2ad4de96dfb87bb3c0c36ab3935483fc452922ae',
      56: '0x2ad4de96dfb87bb3c0c36ab3935483fc452922ae',
    },
    token: tokens.usdc,
    quoteToken: tokens.usdt,
  },
  
  {
    pid: 6,
    lpSymbol: 'USDT-BNB LP',
    lpAddresses: {
      97: '0x7d9d8b70017ccc9233c56e1372bfda74669b9287',
      56: '0x7d9d8b70017ccc9233c56e1372bfda74669b9287',
    },
    token: tokens.usdt,
    quoteToken: tokens.wbnb,
  },
  
  
  {
    pid: 7,
    lpSymbol: 'SOL-USDT LP',
    lpAddresses: {
      97: '0xc680bbfb9aa16888c7a1a6bac8f320e500fb6b9b',
      56: '0xc680bbfb9aa16888c7a1a6bac8f320e500fb6b9b',
    },
    token: tokens.sol,
    quoteToken: tokens.usdt,
  },
  
  {
    pid: 8,
    lpSymbol: 'LINK-USDT LP',
    lpAddresses: {
      97: '0x73fe54d329ecf9e5bc7a5fc615aa70045272334a',
      56: '0x73fe54d329ecf9e5bc7a5fc615aa70045272334a',
    },
    token: tokens.link,
    quoteToken: tokens.usdt,
  },
  

  
// 10 pid completed  next 11   
]

export default farms
